// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer__separator[data-v-6b04379a]:after {\n  content: \"|\";\n  margin: 0 10px;\n}\n.footer-text[data-v-6b04379a] {\n  font-size: 0.625rem;\n}\n.footer-text a[data-v-6b04379a] {\n  text-decoration: none;\n}\nfooter[data-v-6b04379a] {\n  border-top: 1px solid #e8eef1 !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
